import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import LollipopPlotSVG from './components/LollipopPlotSVG';
const LollipopExportedPlot = memo(function LollipopExportedPlot(props) {
    const { axis, data, height, width, maxTickValues, } = props;
    return (_jsx(LollipopPlotSVG, { axis: axis, data: data, width: width, height: height, maxTickValues: maxTickValues, useInlineStyles: true }, void 0));
});
export default LollipopExportedPlot;
